const buildElementsOptions = ({ amount, customerSessionClientSecret, paymentMethodsConfigId }) => {
  const options =
    amount > 0
      ? {
          mode: "payment",
          amount,
          currency: "usd",
          paymentMethodCreation: "manual",
          captureMethod: "manual",
          setupFutureUsage: "off_session"
        }
      : {
          mode: "setup",
          currency: "usd",
          paymentMethodCreation: "manual",
          setupFutureUsage: "off_session"
        };

  if (customerSessionClientSecret) {
    options.customerSessionClientSecret = customerSessionClientSecret;
  }

  if (paymentMethodsConfigId) {
    options.paymentMethodConfiguration = paymentMethodsConfigId;
  }

  return options;
};

export default buildElementsOptions;
